import HTTP from "../HTTP";
import Jsona from "jsona";
import legalHelper from "../helpers/legals";
import pgaHelper from "../helpers/paymentGatewayAccount";
import pgcHelper from "../helpers/paymentGatewayCustomer";
import accountableHelper from "@/API/helpers/accountables";
import paramsHelpers from "@/API/helpers/params";

const dataFormatter = new Jsona();

export default {
  async index(text_search, number_page = 1) {
    try {
      let response = {};
      const pagination = { number: `${number_page}`, size: "20" };

      if (!(text_search.length == 14 && !isNaN(text_search))) {
        response = await this.searchByName(
          text_search,
          ["profile"],
          [],
          pagination
        );
      } else {
        response = await this.searchByCNPJ(
          text_search,
          ["account", "account.profile"],
          [],
          pagination
        );
        response.data = response.data.map(legal =>
          accountableHelper.parseAccountableToAccount(legal)
        );
      }

      return response;
    } catch (e) {
      throw "Ocorreu um erro ao listar os clientes B2B!";
    }
  },

  async searchByName(name, includes = [], filters = [], pagination = []) {
    const defaultIncludes = ["accountable"];
    includes = [...includes, ...defaultIncludes];

    filters = [
      ...filters,
      { name: "text_search", value: name },
      { name: "accountable_type", value: "Legal" }
    ];

    let params = paramsHelpers.buildParams({ includes, filters, pagination });
    let url = `accounts${params}`;

    try {
      let res = await HTTP.normal.get(url);
      return {
        data: dataFormatter.deserialize(res.data),
        meta: res.data.meta
      };
    } catch (error) {
      throw error;
    }
  },

  async searchByCNPJ(cnpj, includes = [], filters = [], pagination = []) {
    filters = [...filters, { name: "cnpj", value: cnpj }];

    let params = paramsHelpers.buildParams({ includes, filters, pagination });

    let url = `legals${params}`;

    try {
      let res = await HTTP.normal.get(url);
      return {
        data: dataFormatter.deserialize(res.data),
        meta: res.data.meta
      };
    } catch (error) {
      throw error;
    }
  },

  async show(id) {
    try {
      let results = await HTTP.normal.get(
        `/accounts/${id}?include=profile,accountable,phones&filter[accountable_type]=Legal`
      );
      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar o cliente b2b!";
    }
  },

  async create(payload) {
    try {
      let legal = await HTTP.normal.post(
        `/legals`,
        legalHelper.createRequestBody(payload)
      );
      return dataFormatter.deserialize(legal.data);
    } catch (error) {
      throw error.response.data;
    }
  },

  async createPaymentGatewayAccount(payload, legal) {
    let document = {
      document_type: "CNPJ",
      document_number: legal.cnpj
    };
    try {
      await HTTP.normal.post(
        "/payment-gateway-accounts",
        pgaHelper.createPGARequestBody(payload, legal, document)
      );
      return true;
    } catch (error) {
      throw error.response.data;
    }
  },

  async createPaymentGatewayCustomer(payload, legal) {
    let document = {
      document_type: "CNPJ",
      document_number: legal.cnpj
    };
    try {
      await HTTP.normal.post(
        "/payment-gateway-customers",
        pgcHelper.createPGCRequestBody(payload, legal, document)
      );
    } catch (error) {
      throw error.response.data;
    }
  },

  async getAddresses(id) {
    try {
      let results = await HTTP.normal.get(
        `/legals/${id}?include=addresses.district.city.state.country,addresses.district.pricing`
      );
      results = dataFormatter.deserialize(results.data);
      return results.addresses;
    } catch (e) {
      throw "Ocorreu um erro ao buscar os endereços do cliente!";
    }
  },

  async createOnGateway(account_id) {
    await HTTP.withAccept.post("/payment-gateway-accounts/create-on-gateway", {
      data: {
        attributes: {
          account_id
        }
      }
    });
  },

  async verifyEmail(account_id) {
    let data = {
      data: {
        id: account_id,
        type: "accounts"
      }
    };

    await HTTP.normal.post("/management/email-verification/send", data);
    await HTTP.normal.post("/management/email-verification/verify", data);
  },

  async update(payload) {
    try {
      let account = {
        data: {
          type: "accounts",
          id: payload.id,
          attributes: {
            first_name: payload.first_name,
            last_name: payload.last_name
          }
        }
      };

      let profile = {
        data: {
          type: "profiles",
          id: payload.profile.id,
          attributes: {
            city_name: payload.profile.city_name,
            state_name: payload.profile.state_name
          }
        }
      };

      await HTTP.normal.patch(`/accounts/${account.data.id}`, account);
      await HTTP.normal.patch(`/profiles/${profile.data.id}`, profile);
    } catch (e) {
      throw e.response.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/legals.js